import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto } from "../../../js/ComponentManager";
import { Link } from 'react-router-dom';
/* 개발담당:양유빈
 * 화면기능:주문내역 상세
 * 세부설명:
*/

export class OrderMgrDtl extends Component {
    static displayName = OrderMgrDtl.name;

    constructor(props) {
        super(props);
        this.state = {
            OrderHeader:[],
            OrderDtl: [],
            BuMaster:[]
        };
        this.CsName = Big3Common.ContentState;
        this.Uid = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Uid, "");
        this.Ordgrp_No = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Ordgrp_No, "");

    }
    //초기화
    async componentDidMount() {
        await this.CallOrdMgtMstDtlListData();
    }
    async CallOrdMgtMstDtlListData() {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/OrderMgr/GetOrdMgtMstDtlList',
                {
                    Uid: this.Uid,
                    Ordgrp_No: this.Ordgrp_No
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrderHeader = DataList.OrderHeader;
                const OrderDtl = DataList.OrderDtl;
                const BuMaster = DataList.BuMaster;
                this.setState({ OrderHeader: OrderHeader, OrderDtl: OrderDtl, BuMaster: BuMaster });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtMstDtlListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    CallOrdMgtMstDtlRef = (Uid, Ordgrp_No) => {
        this.Uid = Uid;
        this.Ordgrp_No = Ordgrp_No;
        this.CallOrdMgtMstDtlListData();
    }
    Headerrender() {
        if (this.state.OrderHeader.length === 0) {
            return false;
        }
        const OrderHeader = this.state.OrderHeader[0];
        let BumasterName = this.state.BuMaster.length === 0 ? "" : this.state.BuMaster[0].bumastername || "";
        let Area_Name = this.state.BuMaster.length === 0 ? "" : this.state.BuMaster[0].area_name || "";
        let Qstgrp_No = OrderHeader.qstgrp_no || "";
        let QstUrl = `/Chat/ChatList/Index?qstgrp_no=${Qstgrp_No}&uid=${this.Uid}&whole_name=${OrderHeader.whole_name}`;
        return (
            <div className="order_shop_info_box order_shop_info_box_v2 bn">
                <div className="shop_info">
                    <div className="shop_name">[{Area_Name}]{OrderHeader.whole_name}</div>
                    {Qstgrp_No === "" ? "": <Link to={QstUrl} ><div className="shop_info_icon1" onClick={() => { Big3Common.ModalClose(bootstrap, this.props.id) }}></div></Link>}
                    <div className="shop_info_icon2" onClick={() => { window.location.href = `tel:${OrderHeader.whole_phone}` }}></div>
                    <Link to={`/Chat/LiveChat/Index?uid=${this.Uid}`}>
                        <div className="chat_icon"></div>
                    </Link>
                </div>
                <div className="order_number">주문번호 : {this.Ordgrp_No} </div>
                <div className="order_number">{OrderHeader.reg_dt}</div>
                <div className="shop_address">상가주소 ({OrderHeader.bld_name} {OrderHeader.flr_name}층 {OrderHeader.whole_no_name}호)</div>
                <div className="shop_info_second_line">
                    <div className="shop_info_1">{OrderHeader.pay_idx_nm}</div>
                    {OrderHeader.ord_use === "SS" ? <div className="shop_info_2">사입자 : {BumasterName}</div> : <div className="shop_info_2">{OrderHeader.ord_use_nm}</div>}
                </div>
                <div className="order_status">{OrderHeader.ord_status_nm}</div>
            </div>
        )
    }
    Goodssubrender(OrderList) {
        return (
            <div className="table_box">
                <React.Fragment>
                    <table className="table">
                        <colgroup>
                            <col width="40%" />
                            <col width="12%" />
                            <col width="44%" />
                        </colgroup>
                        <tbody>
                            {OrderList.map(list =>
                                <tr key={list.ordno}>
                                    <td>{list.crd_cd_nm}  / {list.size_nm}  ({Big3Common.Util.Money(list.goods_price)})</td>
                                    <td>{list.quan}</td>
                                    <td>{Big3Common.Util.Money(list.goods_price_sum)}원</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>합계</td>
                                <td>{OrderList.reduce((acc, item) => acc + item.quan, 0)}</td>
                                <td>{Big3Common.Util.Money(OrderList.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                            </tr>
                        </tfoot>
                    </table>
                </React.Fragment>
            </div>
        )
    }
    Goodsrender() {
        const OrderDtl = this.state.OrderDtl;
        const GoodsList = Big3Common.Util.groupBy(OrderDtl, list => list.goods_no);
        const OrdDtListJson = [];
        for (const item of GoodsList.entries()) {
            OrdDtListJson.push({
                "GoodsNo": item[0],
                "OrderList": item[1],
            });
        }
        return (
            <>
                {
                    OrdDtListJson.map(list =>
                        <div className="order_dtl_box" key={list.GoodsNo}>
                            <div className="order_goods_info">
                                <div className="order_goods_img">
                                    <GoodsPhoto
                                        className="order_goods_img_in"
                                        ImageSrc={list.OrderList[0].img_220}
                                    />
                                </div>
                                <div className="order_txt">
                                    <div className="goods_title">{list.OrderList[0].goods_nm}</div>
                                    <div className="goods_price">{Big3Common.Util.Money(list.OrderList[0].goods_price)}원</div>
                                </div>
                            </div>
                            {this.Goodssubrender(list.OrderList)}
                        </div>
                    )
                }
                <div className="table_box sum_table">
                    <React.Fragment>
                        <table className="table">
                            <colgroup>
                                <col width="40%" />
                                <col width="12%" />
                                <col width="44%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td>총 합계</td>
                                    <td>{OrderDtl.reduce((acc, item) => acc + item.quan, 0)}</td>
                                    <td>{Big3Common.Util.Money(OrderDtl.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                                </tr>
                            </tbody>
                        </table>
                    </React.Fragment>
                </div>
            </>
        )
    }
    render() {
        const Headerrender = this.Headerrender();
        const Goodsrender = this.Goodsrender();
        if (this.props.ModalOpen === true) {
            return (
                <div className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id}
                    ref={this.OrderMgrDtlRef}
                    data-bs-keyboard="false"
                    data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="container_box d_padding  p_b_margin" ref={this.OrderMgrDtlRef} style={{ overflowY: "auto", margin:"0 0 0 0" }}>
                                {Headerrender}
                                {Goodsrender}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn" data-bs-dismiss="modal" onClick={this.handleClick}>확인</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="container_box d_padding  p_b_margin" ref={this.OrderMgrDtlRef}>
                    {Headerrender}
                    {Goodsrender}
                </div>
            );
        }
        
    }
}

        